import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { siteConfig, isPlaceholder } from "../config/site";

export default function Datenschutz() {
  const { t } = useLanguage();
  const l = siteConfig.legal;
  const s = t.legal.sections;
  const ph = (v: string) => (isPlaceholder(v) ? <span className="rounded-md bg-clay-50 px-2 py-0.5 font-mono text-sm text-clay">{v}</span> : v);

  const blocks: { title: string; body: React.ReactNode; testId: string }[] = [
    {
      title: s.controller,
      testId: "privacy-controller",
      body: (
        <>
          {s.controllerNote}
          <br />
          {ph(l.officialBusinessName)}
          <br />
          {ph(l.ownerFullName)}
          <br />
          {ph(l.businessAddress)}
          <br />
          <a href={`mailto:${l.businessEmail}`} className="hover:text-clay transition-colors">{l.businessEmail}</a>
          {" · "}
          <a href={`tel:${l.businessPhone}`} className="hover:text-clay transition-colors">{l.businessPhone}</a>
        </>
      ),
    },
    { title: s.ssl, body: s.sslText, testId: "privacy-ssl" },
    { title: s.hosting, body: s.hostingText, testId: "privacy-hosting" },
    { title: s.contactForm, body: s.contactFormText, testId: "privacy-contact-form" },
    {
      title: s.cookies,
      testId: "privacy-cookies",
      body: (
        <>
          {s.cookiesText}{" "}
          <button type="button" className="underline underline-offset-2 text-clay" onClick={() => window.dispatchEvent(new CustomEvent("kp:open-cookie-settings"))} data-testid="privacy-cookie-settings">{t.nav.cookies}</button>
        </>
      ),
    },
    { title: s.maps, body: s.mapsText, testId: "privacy-maps" },
    { title: s.external, body: s.externalText, testId: "privacy-external" },
    { title: s.storage, body: s.storageText, testId: "privacy-storage" },
    { title: s.rights, body: s.rightsText, testId: "privacy-rights" },
    {
      title: s.authority,
      testId: "privacy-authority",
      body: (
        <>
          {s.authorityText}
          <br />
          <span className="text-charcoal-800">{siteConfig.legal.supervisoryAuthority}</span>
        </>
      ),
    },
  ];

  return (
    <main data-testid="datenschutz-page">
      <SEOHead title={t.meta.datenschutz.title} description={t.meta.datenschutz.description} />
      <PageHeader eyebrow={t.nav.datenschutz} title={t.legal.datenschutzTitle} text={t.legal.datenschutzIntro} crumb={t.nav.datenschutz} testId="datenschutz-header" />
      <section className="container-x max-w-3xl pb-24 md:pb-32">
        <ol className="grid gap-10">
          {blocks.map((b, i) => (
            <li key={b.testId} className="grid gap-3 sm:grid-cols-[3rem_1fr]" data-testid={b.testId}>
              <span className="font-display text-xl text-clay/70">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="font-display text-xl font-medium">{b.title}</h2>
                <p className="mt-2 text-charcoal-700 leading-relaxed">{b.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
    </main>
  );
}
